mutation CreateImpactRecord($impactRecordInput: ImpactRecordInput!) {
  createImpactRecord(input: { impactRecordInput: $impactRecordInput }) {
    impactRecord {
      id
    }
  }
}
